import angular from 'angular';
import 'angular-filter';
import 'angular-ui-router';

import { CartBody } from './cart-body.directive/cartBody';
import { CartFilters } from './cart-filters.service/cartFilters';
import { CartRepository } from './cart-repository.service/cartRepository';
import { CartRow } from './cart-row.directive/cartRow';
import { tnCartUpgradeText } from './cart-upgrade-text.directive/cartUpgradeText';
import { CartReview } from './cartReview.controller/cartReview';
import {
    EditStylesController,
    populateEditStylesTemplateCache,
} from './edit-styles/edit-styles';
import {
    populateTemplateCache,
    EmailCartController,
} from './email-cart.view/emailCart';
import {
    populateCouponTemplateCache,
    EnterCouponComponentOptions,
} from './enter-coupon.directive/enter-coupon';
import {
    populateZipCodeTemplateCache,
    EnterZipcodeComponentOptions,
} from './enter-zip-code.directive/enterZipCode';
import { EulaController } from './eula.view/eula';
import { EulaService } from './service.tn.eula';
import { CleanCartFontRightsFilter } from './filters/cleanCartFontRights';
import { LocalCarts } from './local-carts.service/localCarts';
import {
    populateSaveCartTemplateCache,
    SaveCartController,
} from './save-cart.view/save-cart';
import { SavedCartDetail } from './saved-cart-detail.view/savedCartDetail';
import { SavedCartDetailSidebar } from './saved-cart-detail.view/savedCartDetailSidebar';
import { SavedCartsIndexFilters } from './saved-carts-index-filters.view/savedCartsIndexFilters';
import { SavedCartsIndex } from './saved-carts-index.view/savedCartsIndex';
import { CartService } from './service.tn.cart';

export default angular
    .module('tn.cart', [
        'angular.filter',
        'ui.router',
        'tn.django',
        'tn.user',
        'tn.billing',
        'tn.pricing',
        'tn.popover',
        'tn.projects',
        'tn.licenses',
        'tn.utils',
        'tn.ui',
    ])
    // components
    .controller('tn.cart.controller.cartReview', CartReview)
    .controller('tnEditStyles', EditStylesController)
    .controller('tnEmailCart', EmailCartController)
    .controller('tnEula', EulaController)
    .controller('tnSaveCart', SaveCartController)
    .controller('tnSavedCartDetail', SavedCartDetail)
    .controller('tnSavedCartDetailSidebar', SavedCartDetailSidebar)
    .controller('tnSavedCartsIndexFilters', SavedCartsIndexFilters)
    .controller('tnSavedCartsIndex', SavedCartsIndex)
    .directive('tnCartBody', CartBody)
    .directive('tnCartRow', CartRow)
    .directive('tnCartUpgradeText', tnCartUpgradeText)
    .component('tnEnterCoupon', EnterCouponComponentOptions)
    .component('tnEnterZipcode', EnterZipcodeComponentOptions)
    // providers
    .filter('cleanCartFontRights', CleanCartFontRightsFilter)
    .service('cartRepository', CartRepository)
    .service('localCarts', LocalCarts)
    .service('tn.cart.service', CartService)
    // stateful tracker specifically for the account/orders page.
    .service('tnCartFiltersService', CartFilters)
    .service('EulaService', EulaService)
    // bootstrap
    .run(populateCouponTemplateCache)
    .run(populateCouponTemplateCache)
    .run(populateEditStylesTemplateCache)
    .run(populateSaveCartTemplateCache)
    .run(populateTemplateCache)
    .run(populateZipCodeTemplateCache).name;
